import { EUnitOfMeasure } from '../shared/enum';
import { TInputDrainPipeDiameter } from '../shared/iProject';
import { EUnitOfMeasureImperialLabel, EUnitOfMeasureMetricLabel } from './enum';

export const diameter: TInputDrainPipeDiameter = 'diameter';
export const internalDiameter: TInputDrainPipeDiameter = 'internalDiameter';

export const drainPipeDiameterPD = {
    [diameter]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.millimeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.inch,
        },
    },
    [internalDiameter]: {
        unitOfMeasure: {
            [EUnitOfMeasure.Metric]: EUnitOfMeasureMetricLabel.millimeter,
            [EUnitOfMeasure.Imperial]: EUnitOfMeasureImperialLabel.inch,
        },
    },
};
